import { ReactElement } from 'react';

import { Button, ButtonProps, styled } from '@mui/material';

const StyledButton = styled(Button)(({ theme: { palette } }) => ({
  padding: 0,
  minWidth: 0,
  color: '#828D98',
  backgroundColor: 'transparent',
  '&:hover': {
    color: palette.primary.main,
  },
  '&:focus': {
    outline: 'none',
  },
  '&.Mui-disabled': {
    borderColor: palette.action.disabled,
  },
  outline: 'none',
}));

export const HeaderButton = (props: ButtonProps): ReactElement => {
  return (
    <StyledButton aria-label="More Options" {...props}>
      {props.children}
    </StyledButton>
  );
};
